import { render, staticRenderFns } from "./BreadcrumbNav.vue?vue&type=template&id=1f2f9a0c&scoped=true"
import script from "./BreadcrumbNav.vue?vue&type=script&lang=js"
export * from "./BreadcrumbNav.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbNav.vue?vue&type=style&index=0&id=1f2f9a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2f9a0c",
  null
  
)

export default component.exports